import axios from 'axios';

const normalizeApiBase = (rawValue) => {
  const value = (rawValue || '').trim();
  if (!value) return '/api';

  const trimmed = value.replace(/\/+$/, '');

  if (trimmed === '/auth' || trimmed.endsWith('/auth')) {
    return `${trimmed.slice(0, -5)}/api` || '/api';
  }

  if (trimmed === '/api' || trimmed.endsWith('/api')) {
    return trimmed;
  }

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('/')) {
    return `${trimmed}/api`;
  }

  return '/api';
};

const defaultApiBase = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:8000/api'
  : '/api';

const API_URL = normalizeApiBase(process.env.REACT_APP_API_URL || defaultApiBase);

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  try {
    const stored = localStorage.getItem('auth_user');
    if (stored) {
      const user = JSON.parse(stored);
      if (user?.id) {
        config.params = { actor_user_id: user.id, ...(config.params || {}) };
      }
    }
    const viewMode = localStorage.getItem('ipms_view_mode');
    if (viewMode) {
      config.params = { ...(config.params || {}), view_societate: viewMode };
    }
  } catch (_) {}
  return config;
});

export default apiClient;
